import React, {useEffect, useState} from "react";
import {firestore} from "../firebase";
import {useGroup} from "../contexts/GroupContext";
import {Box, Paper} from "@mui/material";
import Typography from "@mui/material/Typography";
import LoadingComponent from "../pages/LoadingComponent";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";

const AdminGroupSwitchComponent = () => {

    const {group, setGroup, setBotSerials, setBotNames} = useGroup()
    const [isReady, setIsReady] = useState(false)
    const [groups, setGroups] = useState([])

    useEffect(() => {
        //Generates listener on groups
        let currentUnsubscriber;
        const generateGroupsListener = async () => {
            //Set the listener to dispatch all groups. Return unsubscriber
            currentUnsubscriber = await firestore.collection(`groups`).onSnapshot(snapshot => {
                let groupList = []
                snapshot.docs.forEach(doc => {
                    groupList.push(doc.id)
                })
                setGroups(groupList)
            });
        }

        //set listener and unsubscriber
        generateGroupsListener()

        //Cleanup effect
        return () => {
            currentUnsubscriber()
        }

    }, [group])

    //Component is ready to render if all the groups are available
    useEffect(() => {
        if (groups.length !== 0) {
            setIsReady(true)
        }
    }, [groups])

    const handleGroupSwitchChange = (event) => {
        setBotSerials([])
        setBotNames([])
        setGroup(event.target.value);
    };

    if (isReady) {
        return (
            <Box>
                <Paper>
                    <Box p={2} display="flex">
                        <Typography variant="h6">Impersonate which group?</Typography>
                    </Box>
                    <TextField onChange={handleGroupSwitchChange} select value={group}
                               id="groupSwitchField" label="Group..." fullWidth>
                        {groups.map((option) => (
                            <MenuItem key={option} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </TextField>
                </Paper>
            </Box>
        );
    } else {
        return (
            <LoadingComponent/>
        )
    }
}

export default AdminGroupSwitchComponent